module.exports = __webpack_public_path__ + "img/gold_medal.89d6f3f1.png";